export default "__VITE_ASSET__4055661b__"